import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_CHAT,
  ENDPOINT_CHAT_FIRST_ITERATIONS,
  ENDPOINT_CHAT_ITERATIONS,
  ENDPOINT_LAST,
  ENDPOINT_ROLLBACK,
} from './constants';

export function useChatService() {
  const { backendGet, backendPost } = Sebrae.useBackend();

  const getLastChatParameter = React.useCallback(
    (id) => backendGet(`${ENDPOINT_LAST}`),
    [backendGet],
  );

  const postRollbackParameters = React.useCallback(
    () => backendPost(`${ENDPOINT_ROLLBACK}`),
    [backendPost],
  );

  const postSaveParameters = React.useCallback(
    (params) => backendPost(`${ENDPOINT_CHAT}`, { ...params }),
    [backendPost],
  );

  const getIterations = React.useCallback(
    ({ id, question }) =>
      backendGet(`${ENDPOINT_CHAT_ITERATIONS}/${id}/question/${question}`),
    [backendGet],
  );

  const firstIteration = React.useCallback(
    (idInterview) =>
      backendGet(`${ENDPOINT_CHAT_FIRST_ITERATIONS}/${idInterview}/initialize`),
    [backendGet],
  );

  return {
    getLastChatParameter,
    postRollbackParameters,
    postSaveParameters,
    getIterations,
    firstIteration,
  };
}
